import { render, staticRenderFns } from "./ItemText.vue?vue&type=template&id=d7753256&scoped=true&"
import script from "./ItemText.vue?vue&type=script&lang=js&"
export * from "./ItemText.vue?vue&type=script&lang=js&"
import style0 from "./ItemText.vue?vue&type=style&index=0&id=d7753256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7753256",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout})
